import React from "react";
const IconShipping = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="none" viewBox="0 0 20 20" {...props}>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m1 4 1-1h11l1 1v2h2.5l.858.486 1.5 2.5L19 9.5V14l-1 1h-1.17a3.001 3.001 0 0 1-5.66 0H8.83a3.001 3.001 0 0 1-5.66 0H2l-1-1V4Zm15.83 9H17V9.777L15.934 8H14v3c1.306 0 2.418.835 2.83 2ZM14 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-2-1.236V5H3v8h.17a3.001 3.001 0 0 1 5.66 0h2.34c.17-.48.459-.904.83-1.236ZM5 14a1 1 0 1 1 2 0 1 1 0 0 1-2 0Z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconShipping;
